import styled from 'styled-components'
const AppWrapper = styled.div<{
  width?: any
}>`
  width: 100%;
  position: relative;
  .slider {
    display: flex;
    width: 100%;
    align-items: center;
  }
  .blue {
    width: ${(props) => (props.width ? props.width : '10%')};
    height: 40px;
    background-color: ${({ theme }) => theme.colors.secondPrimary};
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      height: 10px;
    }
  }
  .circle {
    height: 80px;
    width: 80px;
    border-radius: 50%;
    background-color: white;
    outline: 13px solid ${({ theme }) => theme.colors.secondPrimary};
    position: inherit;
    z-index: 2;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      height: 27px;
      width: 27px;
      outline: 4px solid ${({ theme }) => theme.colors.secondPrimary};
    }
  }
  .white {
    width: auto;
    height: 40px;
    background-color: #6e7191;
    opacity: 0.3;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      height: 10px;
    }
  }
  .line {
    width: 100%;
    height: 40px;
    background-color: #6e7191;
    opacity: 0.3;
    position: absolute;
    border-radius: 11.8706px;
    top: 19px;
    z-index: 1;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      height: 10px;
      top: 7px;
    }
  }
`
function Slider({ width }: { width: any }) {
  return (
    <AppWrapper width={width}>
      <div className="slider">
        <div className="blue"></div>
        <div className="circle"></div>
        <div className="white"></div>
      </div>
      <div className="line"></div>
    </AppWrapper>
  )
}

export { Slider }
